import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
export default class RequestImageService {
    static getImage(endpoint, genericImageProps) {
        return HttpService.get(endpoint, { ...genericImageProps }).then(response => {
            if (!response.body) {
                return '';
            }
            return URL.createObjectURL(response.body);
        }).catch(() => {
            return '';
        });
    }
}
//# sourceMappingURL=request-image-service.js.map